export const productImpressions = (impressions, taxonomyLevel) => ({
  event: 'product_list_impression',
  ecommerce: {
    currencyCode: 'GBP',
    impressions,
  },
  taxonomyLevel,
});
